import isTest from '@purecarslabs/signal-utils/env/isTest'
import {
  DataMiddlewareType,
  ErrorWithResponseType,
  ResponseOrErrorType
} from './types'

// error logging gets disturbed if you redirect too soon
const REDIRECT_DELAY = 1000

let lastErrorRedirect: string
export const clearLastErrorRedirect = (): void => {
  lastErrorRedirect = ''
} // for unit testing
export const getLastErrorRedirect = (): string => lastErrorRedirect // for unit testing

// this middleware redirects to the given path on request errors
const errorRedirectMiddleware = (
  redirectPath: string,
  mockError?: ErrorWithResponseType
): DataMiddlewareType => async (
  respOrError?: ResponseOrErrorType
): Promise<ResponseOrErrorType> => {
  const errorUse = mockError || respOrError
  if (errorUse instanceof Error) {
    const { response = {} as Response } = errorUse as ErrorWithResponseType
    const { status } = response
    const inUnitTest = isTest()

    lastErrorRedirect = `${window.location.origin}${redirectPath}?errorStatus=${status}`
    if (!inUnitTest && window.location.href !== lastErrorRedirect) {
      setTimeout(() => {
        window.location.assign(lastErrorRedirect)
      }, REDIRECT_DELAY)
    }
    return undefined
  }
  return errorUse
}

export default errorRedirectMiddleware
